import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  props: {
    value: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      dialog: false
    }
  },
  computed: {
    ...mapGetters([
      'getterAccount',
      'getterScheduledCallManagerInfo'
    ]),
    options () {
      return {
        loading: this.isLoading
      }
    }
  },
  mounted () {
    this.dialog = true
  },
  methods: {
    ...mapActions([
      'actionGetScheduledInfo',
      'actionCancelSchedule'
    ]),
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },
    closeModal () {
      this.isLoading = this.dialog = false
      this.$emit('closeModalConfirm', true)

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    },
    cancelScheduling () {
      this.isLoading = true
      const params = {
        id: this.getterScheduledCallManagerInfo[0]._id,
        idUser: this.getterAccount.user_id,
        nameUser: this.getterAccount.userName
      }

      this.actionCancelSchedule(params)
        .then(() => {
          this.isLoading = false

          this.sendToast({
            text: 'Cancelamento registrado com sucesso!',
            type: 'success'
          })

          this.closeModal()
        })
        .catch(() => {
          this.isLoading = false
          this.sendToast({
            text: 'Não foi possível efetuar o cancelamento, tente novamente mais tarde!',
            type: 'danger'
          })
        })

      this.closeModal()
      this.$emit('closeAll', true)
    }
  }
}
